import { useEffect, useState } from "react";
import { Divider, Grid } from "@mui/material";
import HeaderPanelControl from "./header";
import TableProductsPanel from "./table_products";
import TableProcesosPanel from "./table_procesos";
import Reportar from "./components/reportar";
import ModalAlmacenes from "./components/modalAlmacenes";
import ModalCarga from "./components/modales/modalCharge";
import { GetAllAlmacenesList } from "../../../hooks/getListAlmacen";
import {
  GetMovimientosByAlmacen,
  GetMovimientosByAlmacenCargados,
  GetMovimientosByAlmacenProcesados,
} from "../../../hooks/getMovimientosByAlmacen";
import TablaGeneral from "./components/table_general";
import { EstatusMovimientoEnum } from "../../../@enums/status_mov_inv";
import array_first_seen from "../../../helpers/arrayFirstSeen";
import { AreaAlmacenEnum } from "../../../@enums/tipo_almacen";
import { ModalSplit } from "./components/modales/modalSplit";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { NoAccess } from "../../errors/no_access";
import { ModalEtiquetas } from "./components/modales/modalEtiquetas";
import { ModalMerge } from "./components/modales/modalMerge";
import { ModalPackingList } from "./components/modales/modalPackingList";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { AyudasVisualesPanel } from "./components/ayudasVisuales";
import { GetProcesadosTurno } from "../../../hooks/reportesTurno";
import { GetCertificados } from "../../../hooks/getCertificados";
import ModalEncuesta from "../almacenes/components/modales/modalEncuesta/modalEncuesta";
import {
  AnswerCuestionario,
  VerifyAnswerCheckAlmacen,
  VerifyCheckAlmacen,
} from "../../../hooks/checkAlmacen";
import { ModalCertificadoResponse } from "../almacenes/components/certificados/certificadoResponse";
import { useLoading } from "../../../components/Loading/useLoading";

const selectPermission = (state) => state.auth.permissions;
const selectPermissions = createSelector([selectPermission], (permissions) => ({
  permissions,
}));

const PanelDeControlIndex = () => {
  const { permissions } = useSelector(selectPermissions);
  const { getCertificadosMutation } = GetCertificados();
  const { getAllAlmacenesListMutation } = GetAllAlmacenesList();
  const { answerCuestionarioMutation } = AnswerCuestionario();
  const { getMovimientosByAlmacenMutation } = GetMovimientosByAlmacen();
  const { verifyCheckAlmacenMutation } = VerifyCheckAlmacen();
  const { getMovimientosByAlmacenCargadosMutation } =
    GetMovimientosByAlmacenCargados();
  const { getMovimientosByAlmacenProcesadosMutation } =
    GetMovimientosByAlmacenProcesados();
  const { getProcesadosTurno } = GetProcesadosTurno();
  const [seccionId, setSeccionId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [almacenes, setAlmacenes] = useState([]);
  const [movGen, setMovGen] = useState([]);
  const [movCar, setMovCar] = useState([]);
  const [movPros, setMovPros] = useState([]);
  const [openAyudas, setOpenAyudas] = useState(false);
  const [ayudasVisuales, setAyudasVisuales] = useState(null);
  const [openCargas, setOpenCargas] = useState(false);
  const [isCharge, setIsCharge] = useState(false);
  const [optionSelect, setOptionsSelect] = useState([]);
  const [nameAlm, setNameAlm] = useState("");
  const [totalPros, setTotalPros] = useState(0);
  const [isReporting, setIsReporting] = useState(false);
  const [movReporting, setMovReporting] = useState(null);
  const [saveRepor, setSaveReport] = useState(false);
  const [canReport, setCanReport] = useState(true);
  const [openSplit, setOpenSplit] = useState(false);
  const [noAccess, setNoAccess] = useState(false);
  const [openReprint, setOpenReprint] = useState(false);
  const [openMerge, setOpenMerge] = useState(false);
  const [openPackingList, setOpenPackingList] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [cuestionarios, setCuestionarios] = useState([]);
  const [showCertificado, setShowCertificado] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [cuesId, setCuesId] = useState(null);
  const [color, setColor] = useState(null);
  const [blockButton, setBlockButton] = useState(false); 

  const dispatch = useDispatch();
  const { setAppLoading } = useLoading();

  const turnos = useSelector((state) => state.app.turnos);

  function getMovimientos(id) {
    getMovimientosByAlmacenMutation(
      { id: id, status: EstatusMovimientoEnum.ACTIVO, clave: filtro },
      {
        onSuccess: (x) => {
          setMovGen(x);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  }
  function get_Cargados(id) {
    getMovimientosByAlmacenCargadosMutation(
      { id: id, clave: "" },
      {
        onSuccess: (y) => {
          const option = y.map((item) => {
            return {
              id: item?.part_id,
              label: item?.codigo,
            };
          });
          setOptionsSelect(option);
          setMovCar(y);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  }
  function get_procesados(id) {
    getMovimientosByAlmacenProcesadosMutation(
      { id: id },
      {
        onSuccess: (z) => {
          //Procesar activos
          let prod =
            almacenes?.find((a) => a?.id === seccionId)?.area ===
            AreaAlmacenEnum.PRODUCCION;
          let data_orden = array_first_seen(z?.data);
          let data_to_array = {};
          data_orden?.forEach((objeto) => {
            if (
              !data_to_array[
                prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
              ]
            ) {
              data_to_array[
                prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
              ] = {
                codigo: objeto?.codigo,
                moin_agrupadorprocesado: objeto?.moin_agrupadorprocesado,
                acciones: objeto?.acciones,
                nombre: objeto?.nombre,
                almacen: objeto?.almacen,
                cues_id: objeto?.cues_id,
                cuestionario: objeto?.cuestionario,
                part_id: objeto?.part_id,
                datos: [],
                activo: true,
              };
            }
            // Añadimos el objeto serial, etiqueta y cantidad al array de datos
            data_to_array[
              prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
            ].datos.push({
              serial: objeto?.serial,
              tag: objeto?.tag,
              tag_id: objeto?.tag_id,
              existencia_total: objeto?.existencia_total,
              moin_id: objeto?.moin_id,
              rack: objeto?.rack,
              estacion: objeto?.estacion,
            });
          });
          const data_grouped = Object.values(data_to_array);

          //Procesar inactivos
          let data_inc = array_first_seen(z?.data_inactive);
          let data_to_array_inc = {};
          data_inc?.forEach((objeto) => {
            if (
              !data_to_array_inc[
                prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
              ]
            ) {
              data_to_array_inc[
                prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
              ] = {
                codigo: objeto?.codigo,
                moin_agrupadorprocesado: objeto?.moin_agrupadorprocesado,
                acciones: objeto?.acciones,
                nombre: objeto?.nombre,
                almacen: objeto?.almacen,
                cues_id: objeto?.cues_id,
                cuestionario: objeto?.cuestionario,
                part_id: objeto?.part_id,
                datos: [],
                activo: false,
              };
            }
            // Añadimos el objeto serial, etiqueta y cantidad al array de datos
            data_to_array_inc[
              prod ? objeto?.moin_agrupadorprocesado : objeto?.part_id
            ].datos.push({
              serial: objeto?.serial,
              tag: objeto?.tag,
              tag_id: objeto?.tag_id,
              existencia_total: objeto?.existencia_total,
              moin_id: objeto?.moin_id,
              rack: objeto?.rack,
              estacion: objeto?.estacion,
            });
          });
          const data_grouped_inc = Object.values(data_to_array_inc);

          let data_total = data_grouped.concat(data_grouped_inc);

          let agrupados = new Set();

          data_total.forEach((objeto) => {
            agrupados.add(objeto.part_id);
          });
          console.log(data_total);
          // data_total.sort((a, b) => a.nombre.localeCompare(b.nombre));
          setMovPros(data_total);
        },
        onError: (error) => {
          console.log(error);
        },
        onSettled: () => {
          get_process();
        },
      },
    );
  }
  const get_cuestionarios = (id) => {
    getCertificadosMutation(
      { id, parte: false },
      {
        onSuccess: (data) => {
          setCuestionarios(data);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  };

  const get_process = () => {
    getProcesadosTurno(seccionId, {
      onSuccess: (data) => {
        console.log(data);
        setTotalPros(data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const filter_almacenes_permissions = (data) => {
    const patron = /^MRP:Administracion:Almacenes:(\d+)$/;
    const numerosFinales = permissions.reduce((acumulador, objeto) => {
      const match = objeto.permissionKey.match(patron);
      if (match) {
        acumulador.push(Number(match[1]));
      }
      return acumulador;
    }, []);
    const numerosSet = new Set(numerosFinales);
    const almacenesFiltrados = data.filter((almacen) =>
      numerosSet.has(almacen.id),
    );
    console.log("Almacenes filtrados:", almacenesFiltrados);
    if (almacenesFiltrados.length > 0) {
      console.log("Almacenes filtrados:", almacenesFiltrados);
      setCanReport(
        almacenesFiltrados[0]?.area === AreaAlmacenEnum.LOGISTICA ||
          almacenesFiltrados[0]?.area === AreaAlmacenEnum.SCRAP
          ? false
          : true,
      );
      setAlmacenes(almacenesFiltrados);
      setSeccionId(almacenesFiltrados[0]?.id);
      setNameAlm(almacenesFiltrados[0]?.label?.toUpperCase());
    } else {
      setNoAccess(true);
    }
  };

  const get_list = () => {
    getAllAlmacenesListMutation(
      {},
      {
        onSuccess: (data) => {
          filter_almacenes_permissions(data);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  };

  const handleInputChange = (event) => {
    setFiltro(event.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      getMovimientos(seccionId);
    }
  };

  useEffect(() => {
    dispatch(HEADER_DATA_UPDATE({ nombreData: null }));
    get_list();
  }, []);

  useEffect(() => {
    setCuestionarios([]);
    get_Cargados(seccionId);
    get_procesados(seccionId);
    get_process(seccionId);
    const almacen = almacenes?.find((a) => a?.id === seccionId);
    setColor(almacen?.color);
    const canReportValue =
      almacen?.area === AreaAlmacenEnum.LOGISTICA ||
      almacen?.area === AreaAlmacenEnum.SCRAP
        ? false
        : true;
    if (seccionId) {
      get_cuestionarios(seccionId);
    }
    if (canReportValue) {
      getMovimientos(seccionId);
    } else {
      setMovGen([]);
    }
    setCanReport(canReportValue);
  }, [seccionId]);

  const openProceso = (isCharg) => {
    setIsCharge(isCharg);
    setOpenCargas(true);
  };

  const esAlmacenExterno =
    almacenes?.find((almacen) => almacen?.id === seccionId)?.area ===
    AreaAlmacenEnum.EXTERNO;

  useEffect(() => {
    if (!esAlmacenExterno) {
      setOpenPackingList(false);
    }
  }, [esAlmacenExterno]);

  const btn_seccion = [
    {
      id: 1,
      name: "Cargar",
      disabled: !canReport,
      function: () => openProceso(true),
    },
    {
      id: 2,
      name: "Descargar",
      disabled: !canReport,
      function: () => openProceso(false),
    },
    {
      id: 3,
      name: "Master",
      disabled: false,
      function: () => setOpenSplit(true),
    },
    {
      id: 4,
      name: "Etiquetas",
      disabled: false,
      function: () => setOpenReprint(true),
    },
    {
      id: 5,
      name: "Merge/Split",
      disabled: false,
      function: () => setOpenMerge(true),
    },
    ...(esAlmacenExterno
      ? [
          {
            id: 6,
            name: "Packing list",
            disabled: false,
            function: () => setOpenPackingList(true),
          },
        ]
      : []),
  ];

  const getDataDate = () => {
    const ahora = new Date();
    const horaActual =
      ahora.getHours() * 3600 + ahora.getMinutes() * 60 + ahora.getSeconds();

    // Función para convertir "HH:MM:SS" a segundos
    const timeToSeconds = (timeStr) => {
      const [h, m, s] = timeStr.split(":").map(Number);
      return h * 3600 + m * 60 + s;
    };

    // Función para convertir Date a formato YYYY-MM-DD HH:MM:SS en UTC
    const toUTCString = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // Buscar el turno actual
    const turnoActual = turnos.find((turno) => {
      const inicio = timeToSeconds(turno.turn_horainicio);
      const fin = timeToSeconds(turno.turn_horafin);

      // Turno que NO cruza días (inicio < fin)
      if (inicio < fin) {
        return horaActual >= inicio && horaActual < fin;
      }
      // Turno que SÍ cruza días (inicio > fin)
      else {
        return horaActual >= inicio || horaActual < fin;
      }
    });

    if (!turnoActual) {
      return null; // No se encontró turno
    }

    // Crear las fechas con las horas del turno
    const inicio = timeToSeconds(turnoActual.turn_horainicio);
    const fin = timeToSeconds(turnoActual.turn_horafin);
    const cruzaDias = inicio > fin;

    // Fecha de inicio del turno
    const fechaInicio = new Date(ahora);
    const [hInicio, mInicio, sInicio] = turnoActual.turn_horainicio
      .split(":")
      .map(Number);

    // Si el turno cruza días y la hora actual es menor que la hora de fin,
    // significa que estamos en el día siguiente, entonces la fecha de inicio fue ayer
    if (cruzaDias && horaActual < fin) {
      fechaInicio.setDate(fechaInicio.getDate() - 1);
    }

    fechaInicio.setHours(hInicio, mInicio, sInicio, 0);

    // Fecha de fin del turno
    const fechaFin = new Date(fechaInicio);
    const [hFin, mFin, sFin] = turnoActual.turn_horafin.split(":").map(Number);

    // Si el turno cruza días, la fecha de fin es al día siguiente
    if (cruzaDias) {
      fechaFin.setDate(fechaFin.getDate() + 1);
    }

    fechaFin.setHours(hFin, mFin, sFin, 0);

    return {
      fechaInicio: toUTCString(fechaInicio),
      fechaFin: toUTCString(fechaFin),
    };
  };

  const handleClickDetector = async (accion, onAbort) => {
    setAppLoading(true);
    setBlockButton(true);
    if (cuestionarios.length === 0) {
      accion();
    } else if (!showCertificado && cuestionarios.length > 0) {
      setIsVerifying(true);
      try {
        let fechas = await getDataDate();
        verifyCheckAlmacenMutation(
          {
            id: seccionId,
            startDate: fechas?.fechaInicio,
            endDate: fechas?.fechaFin,
          },
          {
            onSuccess: (data) => {
              console.log("data", data.data);
              if (data.data === false) {
                setCuesId(null);
                setShowCertificado(false);
                accion();
              } else {
                setCuesId(data.data);
                setShowCertificado(true);
                onAbort?.();
              }
            },
            onError: (error) => {
              console.log(error);
              onAbort?.();
            },
            onSettled: () => {
              setIsVerifying(false);
            },
          },
        );
      } catch (error) {
        console.log(error);
        setIsVerifying(false);
        onAbort?.();
      }
    } else {
      onAbort?.();
    }
    setAppLoading(false);
    setBlockButton(false);
  };

  // const saveCertificado = (answers) => {
  //   answerCuestionarioMutation(answers, {
  //     onSuccess: (data) => {
  //       console.log(data);
  //       setShowCertificado(false);
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //     },
  //   });
  // };

  return (
    <>
      {noAccess ? (
        <>
          <NoAccess key={"no_access_almacenes"} />
        </>
      ) : (
        <>
          <HeaderPanelControl
            key="head_panel"
            btn_seccion={btn_seccion}
            setOpen={setOpenModal}
            nameAlm={nameAlm}
            total={totalPros}
            isReporting={isReporting}
            movimiento={movReporting}
            setIsReporting={setIsReporting}
            setMovReporting={setMovReporting}
            setSaveReport={setSaveReport}
            alm={seccionId}
            getMovimientos={getMovimientos}
            get_Cargados={get_Cargados}
            get_procesados={get_procesados}
            checkCert={handleClickDetector}
          />
          <Divider />
          {isReporting ? (
            <Grid container spacing={0}>
              <Reportar
                key="module_reportar"
                movimiento={movReporting}
                setMovReporting={setMovReporting}
                saveReport={saveRepor}
                setSaveReport={setSaveReport}
                setIsReporting={setIsReporting}
                seccionId={seccionId}
                getMovimientos={getMovimientos}
                get_Cargados={get_Cargados}
                get_procesados={get_procesados}
                alm={seccionId}
              />
            </Grid>
          ) : (
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={openAyudas ? 10 : 12}
                lg={openAyudas ? 10 : 12}
                xl={openAyudas ? 10 : 12}
                sx={{ p: 1, alignItems: "flex-start" }}
                className="center_item"
              >
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={canReport ? 6 : 12}
                    lg={canReport ? 7 : 12}
                    xl={canReport ? 7 : 12}
                    className="center_item"
                    sx={{
                      p: 1,
                      justifyContent: "flex-start",
                      flexDirection: "column",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    {canReport && (
                      <TableProductsPanel
                        key={"table_primary"}
                        sample={movCar}
                        almacen={seccionId}
                        updateCargados={get_Cargados}
                        updateGeneral={getMovimientos}
                        setAyudasVisuales={setAyudasVisuales}
                        setOpenAyudas={setOpenAyudas}
                        color={color}
                      />
                    )}

                    <TablaGeneral
                      key={"table_gen_mov_alm"}
                      sample={movGen}
                      setAyudasVisuales={setAyudasVisuales}
                      setOpenAyudas={setOpenAyudas}
                      almacen={seccionId}
                      updateCargados={get_Cargados}
                      updateGeneral={getMovimientos}
                      onPressEnter={handleKeyDown}
                      handleInputChange={handleInputChange}
                      filtro={filtro}
                      canSearch={!canReport}
                      isVerifying={isVerifying}
                      areaAlma={
                        almacenes?.find((a) => a?.id === seccionId)?.area
                      }
                      color={color}
                    />
                  </Grid>
                  {canReport && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={5}
                      xl={5}
                      className="center_item"
                      sx={{ p: 1, alignItems: "flex-start" }}
                    >
                      <TableProcesosPanel
                        key={"table_process"}
                        sample={movPros}
                        codes={optionSelect}
                        almacen={seccionId}
                        movimientos={movCar}
                        get_cargados={get_Cargados}
                        get_procesados={get_procesados}
                        setIsReporting={setIsReporting}
                        setMovReporting={setMovReporting}
                        canReport={canReport}
                        setAyudasVisuales={setAyudasVisuales}
                        setOpenAyudas={setOpenAyudas}
                        needExtraInfo={
                          almacenes?.find((a) => a?.id === seccionId)?.area ===
                          AreaAlmacenEnum.PRODUCCION
                        }
                        checkCert={handleClickDetector}
                        color={color}
                        block={blockButton}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={openAyudas ? 2 : 0}
                lg={openAyudas ? 2 : 0}
                xl={openAyudas ? 2 : 0}
                sx={{ p: 1 }}
              >
                {openAyudas && ayudasVisuales && (
                  <AyudasVisualesPanel
                    key={"ayudas_visuales_gen"}
                    id_part={ayudasVisuales}
                    setAyudas={setAyudasVisuales}
                    setOpenAyudas={setOpenAyudas}
                  />
                )}
              </Grid>
            </Grid>
          )}
        </>
      )}
      <ModalAlmacenes
        key={"modal_alm"}
        open={openModal}
        setOpen={setOpenModal}
        setSeccionId={setSeccionId}
        almacenes={almacenes}
        setAyudas={setAyudasVisuales}
        setOpenAyudas={setOpenAyudas}
        setName={setNameAlm}
        setCanReport={setCanReport}
      />
      <ModalCarga
        key={"modal_cargas"}
        open={openCargas}
        setOpen={setOpenCargas}
        isCharge={isCharge}
        almacen={seccionId}
        getCargados={get_Cargados}
        getMovimiento={getMovimientos}
      />
      <ModalSplit
        key={"modal_split"}
        open={openSplit}
        setOpen={setOpenSplit}
        almacen={seccionId}
      />
      <ModalEtiquetas
        key={"modal_etiquetas"}
        open={openReprint}
        setOpen={setOpenReprint}
        almacen={seccionId}
        get_movimientos={getMovimientos}
      />
      <ModalMerge
        key={"modal_merge_main"}
        open={openMerge}
        setOpen={setOpenMerge}
        almacen={seccionId}
      />
      <ModalPackingList
        key={"modal_packing_list"}
        open={openPackingList}
        setOpen={setOpenPackingList}
        almacen={seccionId}
        cargados={movCar}
      />
      {/* <ModalEncuesta
        key={`modal_enc_${cuestionarios[0]?.cues_id}`}
        open={showCertificado}
        setOpen={setShowCertificado}
        id_cuest={cuestionarios[0]?.cues_id}
        answers={respuestas}
        setAnswers={saveCertificado}
        onlyRead={false}
        cantidad={0}
        keepMounted={true}
      /> */}
      <ModalCertificadoResponse
        key={`modal_cert_${cuesId}`}
        open={showCertificado}
        setOpen={setShowCertificado}
        id_cues={cuesId}
        keepMounted={true}
      />
    </>
  );
};

export default PanelDeControlIndex;
